import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateReportMutationVariables = Types.Exact<{
  input: Types.CreateReportInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'ReportPayload', report?: { __typename?: 'ReportData', reportId: string, tenantId: string, name: string, description: string, dataSourceId: string, folderId?: string | null, craftJsTemplate: string, handlebarsTemplate: string, parameterValues: string, parameterConfig: string, pageSettings: string, filters: string, spreadsheetColumns: string, isStarred: boolean, appTags: Array<Types.AppTag>, status: Types.ReportStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateReportMutationVariables = Types.Exact<{
  input: Types.UpdateReportInput;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'ReportPayload', report?: { __typename?: 'ReportData', reportId: string, tenantId: string, name: string, description: string, dataSourceId: string, folderId?: string | null, craftJsTemplate: string, handlebarsTemplate: string, parameterValues: string, parameterConfig: string, pageSettings: string, filters: string, spreadsheetColumns: string, isStarred: boolean, appTags: Array<Types.AppTag>, status: Types.ReportStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetReportAppTagsMutationVariables = Types.Exact<{
  input: Types.SetReportAppTagsInput;
}>;


export type SetReportAppTagsMutation = { __typename?: 'Mutation', setReportAppTags: { __typename?: 'ReportPayload', report?: { __typename?: 'ReportData', reportId: string, appTags: Array<Types.AppTag> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteReportMutationVariables = Types.Exact<{
  input: Types.DeleteReportInput;
}>;


export type DeleteReportMutation = { __typename?: 'Mutation', deleteReport: { __typename?: 'ReportPayload', report?: { __typename?: 'ReportData', reportId: string, status: Types.ReportStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateReportFolderMutationVariables = Types.Exact<{
  input: Types.CreateReportFolderInput;
}>;


export type CreateReportFolderMutation = { __typename?: 'Mutation', createReportFolder: { __typename?: 'ReportFolderPayload', folder?: { __typename?: 'ReportFolderData', folderId: string, tenantId: string, name: string, parentId?: string | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RenameReportFolderMutationVariables = Types.Exact<{
  input: Types.RenameReportFolderInput;
}>;


export type RenameReportFolderMutation = { __typename?: 'Mutation', renameReportFolder: { __typename?: 'ReportFolderPayload', folder?: { __typename?: 'ReportFolderData', folderId: string, tenantId: string, name: string, parentId?: string | null, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteReportFolderMutationVariables = Types.Exact<{
  input: Types.DeleteReportFolderInput;
}>;


export type DeleteReportFolderMutation = { __typename?: 'Mutation', deleteReportFolder: { __typename?: 'ReportFolderPayload', folder?: { __typename?: 'ReportFolderData', folderId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReportScheduleFieldsFragment = { __typename?: 'ReportScheduleData', scheduleId: string, tenantId: string, name: string, reportId: string, reportTemplateId?: string | null, cronExpression: string, timeZoneId: string, outputFormat: string, recipients: Array<string>, emailSubject?: string | null, emailBody?: string | null, senderId?: string | null, parameters?: string | null, isActive: boolean, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, nextRunAt?: Types.TDateISO | null, lastRunAt?: Types.TDateISO | null, runOnce: boolean, orderId?: string | null, orderNumber?: string | null, docType?: Types.OrderEmailDocType | null, status: Types.ReportScheduleStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO };

export type CreateReportScheduleMutationVariables = Types.Exact<{
  input: Types.CreateReportScheduleInput;
}>;


export type CreateReportScheduleMutation = { __typename?: 'Mutation', createReportSchedule: { __typename?: 'ReportSchedulePayload', reportSchedule?: { __typename?: 'ReportScheduleData', scheduleId: string, tenantId: string, name: string, reportId: string, reportTemplateId?: string | null, cronExpression: string, timeZoneId: string, outputFormat: string, recipients: Array<string>, emailSubject?: string | null, emailBody?: string | null, senderId?: string | null, parameters?: string | null, isActive: boolean, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, nextRunAt?: Types.TDateISO | null, lastRunAt?: Types.TDateISO | null, runOnce: boolean, orderId?: string | null, orderNumber?: string | null, docType?: Types.OrderEmailDocType | null, status: Types.ReportScheduleStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateReportScheduleMutationVariables = Types.Exact<{
  input: Types.UpdateReportScheduleInput;
}>;


export type UpdateReportScheduleMutation = { __typename?: 'Mutation', updateReportSchedule: { __typename?: 'ReportSchedulePayload', reportSchedule?: { __typename?: 'ReportScheduleData', scheduleId: string, tenantId: string, name: string, reportId: string, reportTemplateId?: string | null, cronExpression: string, timeZoneId: string, outputFormat: string, recipients: Array<string>, emailSubject?: string | null, emailBody?: string | null, senderId?: string | null, parameters?: string | null, isActive: boolean, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, nextRunAt?: Types.TDateISO | null, lastRunAt?: Types.TDateISO | null, runOnce: boolean, orderId?: string | null, orderNumber?: string | null, docType?: Types.OrderEmailDocType | null, status: Types.ReportScheduleStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetReportScheduleEmailSettingsMutationVariables = Types.Exact<{
  input: Types.SetReportScheduleEmailSettingsInput;
}>;


export type SetReportScheduleEmailSettingsMutation = { __typename?: 'Mutation', setReportScheduleEmailSettings: { __typename?: 'ReportSchedulePayload', reportSchedule?: { __typename?: 'ReportScheduleData', scheduleId: string, tenantId: string, name: string, reportId: string, reportTemplateId?: string | null, cronExpression: string, timeZoneId: string, outputFormat: string, recipients: Array<string>, emailSubject?: string | null, emailBody?: string | null, senderId?: string | null, parameters?: string | null, isActive: boolean, startDate?: Types.TDateISO | null, endDate?: Types.TDateISO | null, nextRunAt?: Types.TDateISO | null, lastRunAt?: Types.TDateISO | null, runOnce: boolean, orderId?: string | null, orderNumber?: string | null, docType?: Types.OrderEmailDocType | null, status: Types.ReportScheduleStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteReportScheduleMutationVariables = Types.Exact<{
  input: Types.DeleteReportScheduleInput;
}>;


export type DeleteReportScheduleMutation = { __typename?: 'Mutation', deleteReportSchedule: { __typename?: 'ReportSchedulePayload', reportSchedule?: { __typename?: 'ReportScheduleData', scheduleId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ClearEmailSuppressionMutationVariables = Types.Exact<{
  input: Types.ClearEmailSuppressionInput;
}>;


export type ClearEmailSuppressionMutation = { __typename?: 'Mutation', clearEmailSuppression: { __typename?: 'ClearEmailSuppressionPayload', cleared: boolean, email: string, listType?: Types.EmailSuppressionListType | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RevertReportMutationVariables = Types.Exact<{
  reportId: Types.Scalars['String']['input'];
  version: Types.Scalars['Long']['input'];
}>;


export type RevertReportMutation = { __typename?: 'Mutation', revertReport: { __typename?: 'ReportPayload', report?: { __typename?: 'ReportData', reportId: string, tenantId: string, name: string, description: string, dataSourceId: string, folderId?: string | null, craftJsTemplate: string, handlebarsTemplate: string, parameterValues: string, parameterConfig: string, pageSettings: string, filters: string, spreadsheetColumns: string, isStarred: boolean, appTags: Array<Types.AppTag>, status: Types.ReportStatus, createdBy: string, createdAt: Types.TDateISO, updatedBy: string, updatedAt: Types.TDateISO } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ReportExecutionDataFieldsFragment = { __typename?: 'ReportExecutionData', executionId: string, reportId: string, reportName?: string | null, reportVersion?: number | null, executedBy: string, executedAt: Types.TDateISO, parameters?: string | null, success: boolean, errorMessage?: string | null, pdfSizeBytes: number, artifactSha256?: string | null };

export type RunReportMutationVariables = Types.Exact<{
  input: Types.RunReportInput;
}>;


export type RunReportMutation = { __typename?: 'Mutation', runReport: { __typename?: 'RunReportPayload', outcome?: Types.RunReportOutcome | null, pdfBase64?: string | null, artifactSha256?: string | null, errorMessage?: string | null, reportExecution?: { __typename?: 'ReportExecutionData', executionId: string, reportId: string, reportName?: string | null, reportVersion?: number | null, executedBy: string, executedAt: Types.TDateISO, parameters?: string | null, success: boolean, errorMessage?: string | null, pdfSizeBytes: number, artifactSha256?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const ReportScheduleFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReportScheduleFields on ReportScheduleData {
  scheduleId
  tenantId
  name
  reportId
  reportTemplateId
  cronExpression
  timeZoneId
  outputFormat
  recipients
  emailSubject
  emailBody
  senderId
  parameters
  isActive
  startDate
  endDate
  nextRunAt
  lastRunAt
  runOnce
  orderId
  orderNumber
  docType
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}
    `, {"fragmentName":"ReportScheduleFields"});
export const ReportExecutionDataFieldsFragmentDoc = new TypedDocumentString(`
    fragment ReportExecutionDataFields on ReportExecutionData {
  executionId
  reportId
  reportName
  reportVersion
  executedBy
  executedAt
  parameters
  success
  errorMessage
  pdfSizeBytes
  artifactSha256
}
    `, {"fragmentName":"ReportExecutionDataFields"});
export const CreateReportDocument = new TypedDocumentString(`
    mutation CreateReport($input: CreateReportInput!) {
  createReport(input: $input) {
    report {
      reportId
      tenantId
      name
      description
      dataSourceId
      folderId
      craftJsTemplate
      handlebarsTemplate
      parameterValues
      parameterConfig
      pageSettings
      filters
      spreadsheetColumns
      isStarred
      appTags
      status
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    errors {
      code
      message
    }
  }
}
    `);
export const UpdateReportDocument = new TypedDocumentString(`
    mutation UpdateReport($input: UpdateReportInput!) {
  updateReport(input: $input) {
    report {
      reportId
      tenantId
      name
      description
      dataSourceId
      folderId
      craftJsTemplate
      handlebarsTemplate
      parameterValues
      parameterConfig
      pageSettings
      filters
      spreadsheetColumns
      isStarred
      appTags
      status
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    errors {
      code
      message
    }
  }
}
    `);
export const SetReportAppTagsDocument = new TypedDocumentString(`
    mutation SetReportAppTags($input: SetReportAppTagsInput!) {
  setReportAppTags(input: $input) {
    report {
      reportId
      appTags
    }
    errors {
      code
      message
    }
  }
}
    `);
export const DeleteReportDocument = new TypedDocumentString(`
    mutation DeleteReport($input: DeleteReportInput!) {
  deleteReport(input: $input) {
    report {
      reportId
      status
    }
    errors {
      code
      message
    }
  }
}
    `);
export const CreateReportFolderDocument = new TypedDocumentString(`
    mutation CreateReportFolder($input: CreateReportFolderInput!) {
  createReportFolder(input: $input) {
    folder {
      folderId
      tenantId
      name
      parentId
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    errors {
      code
      message
    }
  }
}
    `);
export const RenameReportFolderDocument = new TypedDocumentString(`
    mutation RenameReportFolder($input: RenameReportFolderInput!) {
  renameReportFolder(input: $input) {
    folder {
      folderId
      tenantId
      name
      parentId
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    errors {
      code
      message
    }
  }
}
    `);
export const DeleteReportFolderDocument = new TypedDocumentString(`
    mutation DeleteReportFolder($input: DeleteReportFolderInput!) {
  deleteReportFolder(input: $input) {
    folder {
      folderId
    }
    errors {
      code
      message
    }
  }
}
    `);
export const CreateReportScheduleDocument = new TypedDocumentString(`
    mutation CreateReportSchedule($input: CreateReportScheduleInput!) {
  createReportSchedule(input: $input) {
    reportSchedule {
      ...ReportScheduleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ReportScheduleFields on ReportScheduleData {
  scheduleId
  tenantId
  name
  reportId
  reportTemplateId
  cronExpression
  timeZoneId
  outputFormat
  recipients
  emailSubject
  emailBody
  senderId
  parameters
  isActive
  startDate
  endDate
  nextRunAt
  lastRunAt
  runOnce
  orderId
  orderNumber
  docType
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}`);
export const UpdateReportScheduleDocument = new TypedDocumentString(`
    mutation UpdateReportSchedule($input: UpdateReportScheduleInput!) {
  updateReportSchedule(input: $input) {
    reportSchedule {
      ...ReportScheduleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ReportScheduleFields on ReportScheduleData {
  scheduleId
  tenantId
  name
  reportId
  reportTemplateId
  cronExpression
  timeZoneId
  outputFormat
  recipients
  emailSubject
  emailBody
  senderId
  parameters
  isActive
  startDate
  endDate
  nextRunAt
  lastRunAt
  runOnce
  orderId
  orderNumber
  docType
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}`);
export const SetReportScheduleEmailSettingsDocument = new TypedDocumentString(`
    mutation SetReportScheduleEmailSettings($input: SetReportScheduleEmailSettingsInput!) {
  setReportScheduleEmailSettings(input: $input) {
    reportSchedule {
      ...ReportScheduleFields
    }
    errors {
      code
      message
    }
  }
}
    fragment ReportScheduleFields on ReportScheduleData {
  scheduleId
  tenantId
  name
  reportId
  reportTemplateId
  cronExpression
  timeZoneId
  outputFormat
  recipients
  emailSubject
  emailBody
  senderId
  parameters
  isActive
  startDate
  endDate
  nextRunAt
  lastRunAt
  runOnce
  orderId
  orderNumber
  docType
  status
  createdBy
  createdAt
  updatedBy
  updatedAt
}`);
export const DeleteReportScheduleDocument = new TypedDocumentString(`
    mutation DeleteReportSchedule($input: DeleteReportScheduleInput!) {
  deleteReportSchedule(input: $input) {
    reportSchedule {
      scheduleId
    }
    errors {
      code
      message
    }
  }
}
    `);
export const ClearEmailSuppressionDocument = new TypedDocumentString(`
    mutation ClearEmailSuppression($input: ClearEmailSuppressionInput!) {
  clearEmailSuppression(input: $input) {
    cleared
    email
    listType
    errors {
      code
      message
    }
  }
}
    `);
export const RevertReportDocument = new TypedDocumentString(`
    mutation RevertReport($reportId: String!, $version: Long!) {
  revertReport(reportId: $reportId, version: $version) {
    report {
      reportId
      tenantId
      name
      description
      dataSourceId
      folderId
      craftJsTemplate
      handlebarsTemplate
      parameterValues
      parameterConfig
      pageSettings
      filters
      spreadsheetColumns
      isStarred
      appTags
      status
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
    errors {
      code
      message
    }
  }
}
    `);
export const RunReportDocument = new TypedDocumentString(`
    mutation RunReport($input: RunReportInput!) {
  runReport(input: $input) {
    outcome
    reportExecution {
      ...ReportExecutionDataFields
    }
    pdfBase64
    artifactSha256
    errorMessage
    errors {
      code
      message
    }
  }
}
    fragment ReportExecutionDataFields on ReportExecutionData {
  executionId
  reportId
  reportName
  reportVersion
  executedBy
  executedAt
  parameters
  success
  errorMessage
  pdfSizeBytes
  artifactSha256
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateReport: build.mutation<CreateReportMutation, CreateReportMutationVariables>({
      query: (variables) => ({ document: CreateReportDocument, variables })
    }),
    UpdateReport: build.mutation<UpdateReportMutation, UpdateReportMutationVariables>({
      query: (variables) => ({ document: UpdateReportDocument, variables })
    }),
    SetReportAppTags: build.mutation<SetReportAppTagsMutation, SetReportAppTagsMutationVariables>({
      query: (variables) => ({ document: SetReportAppTagsDocument, variables })
    }),
    DeleteReport: build.mutation<DeleteReportMutation, DeleteReportMutationVariables>({
      query: (variables) => ({ document: DeleteReportDocument, variables })
    }),
    CreateReportFolder: build.mutation<CreateReportFolderMutation, CreateReportFolderMutationVariables>({
      query: (variables) => ({ document: CreateReportFolderDocument, variables })
    }),
    RenameReportFolder: build.mutation<RenameReportFolderMutation, RenameReportFolderMutationVariables>({
      query: (variables) => ({ document: RenameReportFolderDocument, variables })
    }),
    DeleteReportFolder: build.mutation<DeleteReportFolderMutation, DeleteReportFolderMutationVariables>({
      query: (variables) => ({ document: DeleteReportFolderDocument, variables })
    }),
    CreateReportSchedule: build.mutation<CreateReportScheduleMutation, CreateReportScheduleMutationVariables>({
      query: (variables) => ({ document: CreateReportScheduleDocument, variables })
    }),
    UpdateReportSchedule: build.mutation<UpdateReportScheduleMutation, UpdateReportScheduleMutationVariables>({
      query: (variables) => ({ document: UpdateReportScheduleDocument, variables })
    }),
    SetReportScheduleEmailSettings: build.mutation<SetReportScheduleEmailSettingsMutation, SetReportScheduleEmailSettingsMutationVariables>({
      query: (variables) => ({ document: SetReportScheduleEmailSettingsDocument, variables })
    }),
    DeleteReportSchedule: build.mutation<DeleteReportScheduleMutation, DeleteReportScheduleMutationVariables>({
      query: (variables) => ({ document: DeleteReportScheduleDocument, variables })
    }),
    ClearEmailSuppression: build.mutation<ClearEmailSuppressionMutation, ClearEmailSuppressionMutationVariables>({
      query: (variables) => ({ document: ClearEmailSuppressionDocument, variables })
    }),
    RevertReport: build.mutation<RevertReportMutation, RevertReportMutationVariables>({
      query: (variables) => ({ document: RevertReportDocument, variables })
    }),
    RunReport: build.mutation<RunReportMutation, RunReportMutationVariables>({
      query: (variables) => ({ document: RunReportDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateReportMutation, useUpdateReportMutation, useSetReportAppTagsMutation, useDeleteReportMutation, useCreateReportFolderMutation, useRenameReportFolderMutation, useDeleteReportFolderMutation, useCreateReportScheduleMutation, useUpdateReportScheduleMutation, useSetReportScheduleEmailSettingsMutation, useDeleteReportScheduleMutation, useClearEmailSuppressionMutation, useRevertReportMutation, useRunReportMutation } = injectedRtkApi;
